import { useCallback, useEffect, useState } from 'react';
import Api from '../../../services';
import { StationOrder } from '../../../types/station-journey';

type DispatchStatusState = {
  loading: boolean;
  order: StationOrder | null;
  errorCode: string | null;
};

const TERMINAL_STATUSES = ['successful', 'failed', 'timed_out'];

export default function useDispatchStatus(orderId: string | undefined) {
  const [state, setState] = useState<DispatchStatusState>({
    loading: true,
    order: null,
    errorCode: null,
  });

  const fetchOrder = useCallback(async () => {
    if (!orderId) {
      setState({ loading: false, order: null, errorCode: 'invalid_order' });
      return null;
    }

    try {
      const response = await Api.orders.getOrder(orderId);
      const order = response.result;
      setState({ loading: false, order, errorCode: null });
      return order;
    } catch {
      setState((current) => ({ ...current, loading: false, errorCode: 'status_unavailable' }));
      return null;
    }
  }, [orderId]);

  useEffect(() => {
    let active = true;
    let timeoutId: ReturnType<typeof setTimeout> | undefined;

    const poll = async () => {
      const order = await fetchOrder();
      if (
        active
        && order
        && !TERMINAL_STATUSES.includes(order.dispatch_status)
      ) {
        timeoutId = setTimeout(poll, 1500);
      }
    };

    poll();

    return () => {
      active = false;
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [fetchOrder]);

  return { ...state, refresh: fetchOrder };
}
